import * as React from 'react'
import { FormattedMessage } from 'mz-intl';
import Button from 'mz-ui-kit/core/Button'
import TermsAndConditionsLightbox from '../TermsAndConditionsLightbox';
import config from 'config';
import messages from '../messages.intl'


const TermsAndConditions = ({
  termsOfServiceURL,
  areTermsInternal,
  prefixMessage,
}) => {
  const [showLightbox, setShowLightbox] = React.useState(false)

  const getMozioTerms = () => (
    <Button
      appearance="link"
      href="/terms-of-service"
      target="_blank"
      $as="a"
    >
      <FormattedMessage message={messages.TERMS_AND_CONDITIONS} />
    </Button>
  )

  const getInternalTerms = () => (
    <Button
      appearance="link"
      $as="a"
      onClick={() => setShowLightbox(true)}
    >
      <FormattedMessage message={messages.TERMS_AND_CONDITIONS} />
    </Button>
  )

  const getExternalTerms = () => (
    <Button
      appearance="link"
      href={termsOfServiceURL}
      target="_blank"
      $as="a"
    >
      <FormattedMessage message={messages.TERMS_AND_CONDITIONS} />
    </Button>
  )

  return (
    <span>
      {!termsOfServiceURL && config.MOZIO_TERMS_AND_CONDITIONS_SHOW && (
        <span>
          <FormattedMessage
            message={prefixMessage}
            values={{ mozio_link: getMozioTerms() }}
          />
          &nbsp;
        </span>
      )}
      {termsOfServiceURL && (
        <span>
          <FormattedMessage
            message={prefixMessage}
            values={{ mozio_link: getMozioTerms() }}
          />
          &nbsp;
          <FormattedMessage
            message={messages.PROVIDER_TERMS_AND_CONDITIONS}
            values={{ provider_link: areTermsInternal
              ? getInternalTerms()
              : getExternalTerms()
            }}
          />
        </span>
      )}
      {showLightbox && (
        <TermsAndConditionsLightbox
          termsOfServiceURL={termsOfServiceURL}
          onClose={() => setShowLightbox(false)}
        />
      )}
    </span>
  );
}

export default TermsAndConditions
